
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19 5C19 3.9 18.1 3 17 3H10.83C10.3 3 9.78999 3.21 9.40999 3.59L7.94999 5.06L19 16.11V5ZM3.08999 4.44C2.69999 4.83 2.69999 5.46 3.08999 5.85L4.99999 7.78V19C4.99999 20.11 5.89999 21 6.99999 21H18.23L19.14 21.91C19.53 22.3 20.16 22.3 20.55 21.91C20.94 21.52 20.94 20.89 20.55 20.5L4.49999 4.44C4.10999 4.05 3.47999 4.05 3.08999 4.44Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-signal-cellular-no-sim`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSignalCellularNoSim

    ```js
    <b-new-b-icon-signal-cellular-no-sim />
    ```
</docs>


